import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { routePath } from '@constants/path';

import { Body } from './Loadable';

export default function RoutesLayout() {
  return (
    <>
      <Switch>
        {/* /mbti/:uuid 를 /:id 보다 먼저 매칭 */}
        <Route component={Body} exact path={routePath.mbtiByUuid.path} />
        <Route component={Body} exact path={routePath.survey.path} />

        {/* NotFoundError */}
        <Route component={Body} path="*" />
      </Switch>
    </>
  );
}
